import Vue from 'vue';
import Component from 'vue-class-component';
import { Language } from '../Models/Language';
import ApiProvider from 'Api/ApiProvider';
import { Prop } from 'vue-property-decorator';
import "jquery";

@Component({})
export default class LoginComponent extends Vue {
    @Prop()
    siteTags: string;

    userExists: boolean = true;
    username: string = '';
    password: string = '';
    action: string = '';
    loading: boolean = false;
    error: string = null;
    isSubmitted: boolean = false;
    locale: string = this.getLocale();

    languages: Language[] = [
        new Language("English", "en"),
        new Language("Nederlands", "nl"),
        new Language("Française", "fr"),
        new Language("русский", "ru"),
        new Language("Dansk", "da"),
        new Language("Deutsch", "de")
    ];

    get selectedLanguage() {
        return this.languages.filter(a => a.languageCode == this.locale)[0];
    }

    getLocale(): string {
        let locale = $.cookie("locale");

        if (!locale) {
            locale = "en";
        }

        return locale;
    }

    setLocale(language: Language) {
        $.cookie('locale', language.languageCode, { expires: 7 });
        this.locale = language.languageCode;
        this.$i18n.locale = language.languageCode;
    }

    async login() {
        this.loading = true;
        let siteTags = this.siteTags.split(",");

        let clients = ApiProvider.getUserClients(siteTags);

        const promises = clients.map(async (client) => {
            let userExists = await client.getUserExists(this.username);

            if (userExists) {
                if (!this.isSubmitted) {
                    $.cookie('mydlfsite', client.siteTag, { expires: 30 / 1440, path: '/' });
                    this.isSubmitted = true;
                    this.submit('/' + this.selectedLanguage.languageCode);
                    this.loading = false;
                } else {
                    alert('Duplicate relationships detected!');
                }
            }
        });

        try {
            await Promise.all(promises);

            if (!this.isSubmitted) {
                this.userExists = false;
            }

            this.isSubmitted = false;
        }
        catch (e) {
            this.error = (e as Error).message;
        }

        this.loading = false;
    }

    submit(url: string) {
        let form = $('<form action="' + url + '" method="post">' +
            '<input type="hidden" name="Username" value="' + this.username + '"></input>' +
            '<input type="hidden" name="Password" value="' + this.password + '"></input>' + '</form>');
        $('body').append(form);
        $(form).submit();
    }
}
Vue.component('login', LoginComponent);